export default function UpdatesSection() {
  const updates = [
    {
      date: '2026-07-31',
      tag: '平台动态',
      title: '香蕉视频上线4K超清专区，多部重磅大片免费观看',
      summary: '香蕉视频近期完成画质全面升级，新增4K超清专区，涵盖动作、科幻、动画等热门类型，用户无需付费即可体验影院级观影效果。',
    },
    {
      date: '2026-07-29',
      tag: '资源更新',
      title: '红桃视频暑期档热剧集中上线，日更稳定无断档',
      summary: '红桃视频整合暑期热门电视剧资源，包括多部国产高分剧集与海外同步剧，每日固定更新时段，播放流畅不卡顿。',
    },
    {
      date: '2026-07-27',
      tag: '行业快讯',
      title: '91视频推出综艺频道独立入口，内容覆盖更全面',
      summary: '91视频正式拆分综艺频道为独立栏目，新增音乐竞演、户外真人秀、脱口秀等多元内容，更新频率提升至每周15档以上。',
    },
    {
      date: '2026-07-25',
      tag: '平台动态',
      title: '蜜桃视频优化移动端播放器，加载速度提升40%',
      summary: '蜜桃视频完成移动端H5播放器重构，针对不同网络环境智能适配码率，首帧加载时间平均缩短至1.2秒，观看体验大幅优化。',
    },
    {
      date: '2026-07-22',
      tag: '资源更新',
      title: '多平台同步上线《星际征途》系列科幻大作',
      summary: '香蕉视频、红桃视频、91视频同步引入年度科幻巨制《星际征途》系列全季，支持中英双语字幕，高清画质免费点播。',
    },
    {
      date: '2026-07-19',
      tag: '行业快讯',
      title: '国产悬疑剧热度飙升，三大平台竞相扩充推理片库',
      summary: '随着国产悬疑题材持续走热，香蕉视频、红桃视频、蜜桃视频纷纷加大推理、刑侦类内容投入，多部口碑佳作集中展映。',
    },
    {
      date: '2026-07-16',
      tag: '平台动态',
      title: '91视频与蜜桃视频达成内容互补合作，片库互通扩容',
      summary: '两大平台通过内容互补机制扩大各自片库覆盖范围，用户可在任一平台检索到更丰富的电影和电视剧资源，选择更多元。',
    },
  ];

  const sorted = [...updates].reverse();

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
              实时动态
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新快讯
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              追踪主流视频平台最新动态，不错过每一次内容更新和功能升级
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-8">
              {sorted.map((item, i) => (
                <div
                  key={i}
                  className={`relative flex flex-col md:flex-row gap-6 ${
                    i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className="hidden md:block flex-1 md:w-1/2"></div>

                  <div className="absolute left-2.5 md:left-1/2 top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 -translate-x-1/2 mt-1.5 z-10"></div>

                  <div className="flex-1 md:w-1/2 pl-10 md:pl-0">
                    <div className={`bg-background-50 rounded-xl p-4 md:p-5 ${i % 2 === 0 ? 'md:mr-4' : 'md:ml-4'}`}>
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs text-foreground-400">{item.date}</span>
                        <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                          {item.tag}
                        </span>
                      </div>
                      <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                        {item.summary}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}